<template>
    <div class="warpper">
        <div class="contant">
            <div class="right">
                <div>
                    <div style="margin-bottom:15px;display:flex;justify-content:space-between" v-if="showIndex">
                        <div>
                            <el-input v-model="keyword" placeholder="方案编号" class="handle-input mr10" style="width:200px"></el-input>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                        </div>
                        <div>
                            <el-button type="primary" @click="addFee" style="margin-left: 10px;" v-if="perData.allow_add == 1"
                                >{{ $t('common.add') }}</el-button
                            >
                            <el-button type="danger" plain @click="plDtl" style="margin-left: 10px;" v-if="perData.allow_dele == 1"
                                >{{ $t('common.delete') }}</el-button
                            >
                            <el-button type="primary" plain @click="plCheck" style="margin-left: 10px;" v-if="perData.allow_check == 1"
                                >{{ $t('common.audit') }}</el-button
                            >
                            <el-button type="primary" plain @click="plNoCheck" style="margin-left: 10px;" v-if="perData.allow_checkoff == 1"
                                >反审</el-button
                            >
                        </div>
                    </div>
                    <div class="table_head" style="display:flex;justify-content:space-between;align-items:center" v-else>
                        <div>方案:{{ wageType.interesttype_name }}</div>
                        <div class="top">
                            <el-button type="warning" @click="edit" :disabled="!isEdit">{{ $t('common.edit') }}</el-button>
                            <el-button type="success" :disabled="isEdit" @click="saveIt">{{ $t('common.save') }}</el-button>
                            <el-button type="info" :disabled="isEdit" @click="refreshData">撤回</el-button>
                            <el-button @click="handleDetails('1')" style="margin-right:10px">{{ $t('common.back') }}</el-button>
                            <el-dropdown trigger="click" @command="handleCommand">
                                <el-button plain> 更多<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="1" v-if="perData.allow_add == 1">导入</el-dropdown-item>
                                    <el-dropdown-item command="2">{{ $t('common.export') }}</el-dropdown-item>
                                    <el-dropdown-item command="3">导入模板</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
                <el-upload
                    v-show="false"
                    style="border:none;color: #000;"
                    class="biaoge"
                    action=""
                    :on-change="inExcel"
                    :show-file-list="false"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    :auto-upload="false"
                >
                </el-upload>
                <div v-if="showIndex">
                    <el-table
                        style="font-size:14px"
                        :data="tableData"
                        border
                        height="600"
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <template slot="empty">
                            <div style="margin: 0 auto;  position: relative;">
                                <img
                                    src="@/assets/img/dontHave.png"
                                    alt=""
                                    style="width:250px;
                                height:250px;
                                position: fixed;    
                                 transform: translate(-100%,-50%);
                              "
                                />
                            </div>
                        </template>
                        <el-table-column type="selection" width="50"></el-table-column>
                        <el-table-column type="index" width="50" align="center" label="序号"> </el-table-column>
                        <el-table-column prop="interesttype_no" label="方案编号" width="160"></el-table-column>
                        <el-table-column prop="interesttype_name" label="方案名称" width="160"></el-table-column>
                        <el-table-column prop="remark" :label="$t('common.remark')" width="300"></el-table-column>
                        <el-table-column prop="check" :label="$t('common.auditStatus')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.check == 1" type="success" plain>已审核</el-tag>
                                <el-tag v-if="scope.row.check == 0" type="danger" plain>未审核</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="check_man" :label="$t('common.auditor')" width="150"></el-table-column>
                        <el-table-column prop="check_date" :label="$t('common.auditTime')" width="160" sortable></el-table-column>
                        <el-table-column prop="build_man" :label="$t('common.creator')" width="150"></el-table-column>
                        <el-table-column prop="build_date" :label="$t('common.createTime')" width="160" sortable></el-table-column>
                        <el-table-column prop="modify_man" :label="$t('common.modifier')" width="150"></el-table-column>
                        <el-table-column prop="modify_date" :label="$t('common.modifyTime')" width="160" sortable></el-table-column>
                        <el-table-column label="操作" width="150" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="text" class="to-blue-500" @click="handleDetails(scope.row)" v-if="perData.allow_use == 1"
                                    >查看方案</el-button
                                >
                                <el-button type="text" class="to-blue-500" @click="editFee(scope.row)" v-if="perData.allow_edit == 1"
                                    >{{ $t('common.edit') }}</el-button
                                >
                                <el-button type="text" style="color:#F56C6C" @click="deleteFee(scope.row)" v-if="perData.allow_dele == 1"
                                    >{{ $t('common.delete') }}</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="pageIndex"
                            :page-sizes="[20, 30, 40, 50]"
                            :page-size="pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChange"
                            @size-change="pageSizeChange"
                        ></el-pagination>
                    </div>
                </div>

                <div @mouseleave="tableleave" v-else>
                    <vxe-table
                        stripe
                        ref="table"
                        :data="laborCostTable"
                        border
                        height="550"
                        :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isEdit: true, enterToTab: true }"
                        :mouse-config="{ selected: true }"
                        :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa', activeMethod: activeRowMethod }"
                        @cell-mouseenter="tableenter"
                    >
                        <vxe-table-column type="seq" width="70" align="center">
                            <template slot="header">
                                <i class="el-icon-setting"></i>
                            </template>
                            <template slot-scope="scoped">
                                <span class="add_" v-if="scoped.$rowIndex == tableIndex">
                                    <i class="el-icon-circle-plus-outline" @click="addTable"></i>
                                    <i class="el-icon-remove-outline" @click="deleteIt(scoped)"></i>
                                </span>
                                <span v-if="scoped.$rowIndex != tableIndex">
                                    <i style="font-style: normal">{{ scoped.$rowIndex + 1 }}</i>
                                </span>
                            </template>
                        </vxe-table-column>
                        <!-- <vxe-table-column title="产品名称" field="style_name" width="150" :edit-render="{}">
                            <template #default="{ row }">
                                <span>{{ formatStyle(row.style_no) }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row.style_no"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in pullData.stylesec"
                                        :key="item.style_no"
                                        :label="item.style_no + ' - ' + item.style_name"
                                        :value="item.style_no"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column> -->
                        <vxe-table-column title="计息项目类型" field="itemstype_no" width="150" :edit-render="{}">
                            <template #default="{ row }">
                                <span>{{ formatStyletype(row.itemstype_no) }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row.itemstype_no"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="checkType(row.itemstype_no, row)"
                                >
                                    <el-option
                                        v-for="item in pullData.itemstype_dat"
                                        :key="item.kind_no"
                                        :label="item.kind_name"
                                        :value="item.kind_no"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column title="计息项目" field="items_no" width="150" :edit-render="{}">
                            <template #default="{ row }">
                                <span>{{ formatStyle(row.items_no, row) }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <template v-if="row.itemstype_no == 'money'">
                                    <el-select
                                        size="mini"
                                        v-model="row.items_no"
                                        ref="stylefocus"
                                        filterable
                                        default-first-option
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="item in pullData.money"
                                            :key="item.kind_no"
                                            :label="item.kind_no + ' - ' + item.kind_name"
                                            :value="item.kind_no"
                                        ></el-option>
                                    </el-select>
                                </template>

                                <template v-if="row.itemstype_no == 'metal'">
                                    <el-select
                                        size="mini"
                                        v-model="row.items_no"
                                        ref="stylefocus"
                                        filterable
                                        default-first-option
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="item in pullData.metal"
                                            :key="item.kind_no"
                                            :label="item.kind_no + ' - ' + item.kind_name"
                                            :value="item.kind_no"
                                        ></el-option>
                                    </el-select>
                                </template>
                            </template>
                        </vxe-table-column>

                        <vxe-table-column
                            title="利率"
                            width="150"
                            field="rate"
                            :edit-render="{ name: 'input', attrs: { type: 'number' }, autoselect: true, events: { focus: myfocus } }"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input type="number" v-model="row.rate" @blur="$vaildator.all(row, 'rate', 'rate')"></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            title="免息天数"
                            width="150"
                            field="freeday"
                            :edit-render="{ name: 'input', attrs: { type: 'integer' }, autoselect: true, events: { focus: myfocus } }"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input type="number" v-model="row.freeday"></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            title="仓息利率"
                            width="150"
                            field="stockrate"
                            :edit-render="{ name: 'input', attrs: { type: 'number' }, autoselect: true, events: { focus: myfocus } }"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="number"
                                    v-model="row.stockrate"
                                    @blur="$vaildator.all(row, 'rate', 'stockrate')"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            title="仓息免息天数"
                            width="150"
                            field="stockfreeday"
                            :edit-render="{ name: 'input', attrs: { type: 'integer' }, autoselect: true, events: { focus: myfocus } }"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input type="number" v-model="row.stockfreeday"></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            title="备注"
                            field="remark"
                            :edit-render="{ name: 'input', attrs: { type: 'text' }, autoselect: true, events: { focus: myfocus } }"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input type="text" v-model="row.remark" @blur="$vaildator.qty(row)"></vxe-input>
                            </template>
                        </vxe-table-column>
                        <template #empty>
                            <span style="color: red;">
                                <img src="@/assets/img/dontHave.png" style="width:180px" />
                            </span>
                        </template>
                    </vxe-table>
                </div>
            </div>
        </div>
        <el-dialog :title="isAdd ? $t('common.add') : $t('common.edit')" :visible.sync="addfee" width="25%">
            <div>
                <el-form label-position="left" label-width="60px">
                    <el-form-item label="编号：">
                        <el-input v-model="interesttype_no" placeholder="请输入方案编号" :disabled="!isAdd" @blur="interBlur"></el-input>
                    </el-form-item>
                    <el-form-item label="名称：">
                        <el-input v-model="interesttype_name" placeholder="请输入方案名称" @blur="interBlurName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.remark') + '：'">
                        <el-input v-model="remark" placeholder="请输入备注"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="danger" @click="deleteFee" v-if="!isAdd" style="float: left;">{{ $t('common.delete') }}</el-button> -->
                <el-button @click="addfee = false">取 消</el-button>
                <el-button type="primary" @click="addFeeComfirm">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="$t('common.add')" :visible.sync="addtable" width="50%">
            <div>
                <el-form class="form" :model="form">
                    <el-form-item label="产品" required>
                        <mySelect
                            placeholders="请选择产品"
                            v-model="form.style_no"
                            :options="pullData.stylesec"
                            class="select"
                            values="style_no"
                            labels="style_name"
                            keys="style_no"
                        ></mySelect>
                    </el-form-item>
                    <el-form-item label="利率">
                        <el-input v-model="form.rate" placeholder="请输入利率"></el-input>
                    </el-form-item>
                    <el-form-item label="免息天数">
                        <el-input v-model="form.freeday" placeholder="请输入免息天数"></el-input>
                    </el-form-item>
                    <el-form-item label="仓息利率">
                        <el-input v-model="form.stockrate" placeholder="请输入仓息利率"></el-input>
                    </el-form-item>
                    <el-form-item label="仓息免息天数">
                        <el-input v-model="form.stockfreeday" placeholder="请输入仓息免息天数"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.remark')" class="remark">
                        <el-input v-model="form.remark" type="textarea" :area="2" placeholder="请输入备注"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addtable = false">取 消</el-button>
                <el-button type="primary" @click="addTableComfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    interestIndex,
    interestAdd,
    interestPull,
    interestDtlAdd,
    interestDtlIndex,
    interestDtlDel,
    interestDel,
    interestCheck,
    interestUpdate,
    interestImport,
    apiCurrentPermisson
} from '@/request/api';
export default {
    data() {
        return {
            perData: '',
            showIndex: true,
            keyword: '',
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            selectList: [],
            tableData: [],
            laborCostData: [],
            laborCostTable: [],
            leftIndex: '',
            leftName: '',
            wageType: {
                interesttype_no: '',
                interesttype_name: '',
                remark: ''
            },
            addfee: false,
            isAdd: true,
            interesttype_id: '',
            interesttype_no: '',
            interesttype_name: '',
            remark: '',
            addtable: false,
            form: {},
            pullData: {},
            isEdit: true,
            tableIndex: '-1' //列表当前位置
        };
    },
    mounted() {
        // let wageType = JSON.parse(sessionStorage.getItem('wageType'));
        // if (Object.keys(wageType).length > 0) {
        //     this.wageType = wageType;
        // }
        this.getData();
        this.getPull();
        this.getPermission();
    },
    methods: {
        handleDetails(row) {
            this.showIndex = !this.showIndex;
            this.wageType.interesttype_id = row.id;
            this.wageType.interesttype_no = row.interesttype_no;
            this.wageType.interesttype_name = row.interesttype_name;
            this.wageType.remark = row.remark;
            if (row.interesttype_no) {
                interestDtlIndex({ pid: this.wageType.interesttype_id, interesttype_no: row.interesttype_no }).then(res => {
                    this.laborCostTable = res.data;
                });
            }
        },
        // 触发搜索按钮
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        // 多选删除操作----------------------------------------------------------------------------------------------------
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function(item, index, array) {
                arr.push(item.id);
            });
            this.selectList = arr;
        },
        getData() {
            interestIndex({ keyword: this.keyword, page: this.pageIndex, page_size: this.pageSize }).then(res => {
                this.tableData = res.data.data;
                this.pageTotal = res.data.page_total;
            });
        },
        getDetail() {
            interestDtlIndex({ pid: this.wageType.interesttype_id, interesttype_no: this.wageType.interesttype_no }).then(res => {
                this.laborCostTable = res.data;
            });
        },
        getPull() {
            interestPull().then(res => {
                this.pullData = res.data;
            });
        },
        changewage(item) {
            if (!this.isEdit) {
                this.$message.warning('当前正在修改数据，请保存后切换');
                return;
            }
            sessionStorage.setItem('wageType', JSON.stringify(item));
            this.wageType = item;
            this.getDetail();
        },
        addFee() {
            this.isAdd = true;
            this.addfee = true;
            this.interesttype_id = '';
            this.interesttype_no = '';
            this.interesttype_name = '';
            this.remark = '';
        },
        editFee(item) {
            if (!this.isEdit) {
                this.$message.warning('当前正在修改数据，请保存后操作');
                return;
            }
            this.isAdd = false;
            this.addfee = true;
            this.interesttype_id = item.id;
            this.interesttype_no = item.interesttype_no;
            this.interesttype_name = item.interesttype_name;
            this.remark = item.remark;
        },
        interBlur() {
            var pattern1 = /^[^\s]*$/; // 不包含空格的字符串
            var pattern2 = /^[^\u4e00-\u9fa5]+$/; // 匹配汉字的正则表达式
            if (this.interesttype_no == '') {
            } else if (!pattern2.test(this.interesttype_no) || !pattern1.test(this.interesttype_no)) {
                this.interesttype_no = '';
                this.$message.error('方案编号不能包含中文字符或者空格');
                return;
            }
        },
        interBlurName() {
            var pattern1 = /^[^\s]*$/; // 不包含空格的字符串
            if (this.interesttype_name == '') {
            } else if (!pattern1.test(this.interesttype_name)) {
                this.interesttype_name = '';
                this.$message.error('方案名称不能含有空格');
                return;
            }
        },
        addFeeComfirm() {
            if (this.interesttype_no == '') {
                this.$message.warning('请输入方案编号');
                return;
            }
            if (this.interesttype_name == '') {
                this.$message.warning('请输入方案名称');
                return;
            }
            if (this.isAdd) {
                interestAdd({
                    interesttype_no: this.interesttype_no,
                    interesttype_name: this.interesttype_name,
                    dtl: [],
                    remark: this.remark
                }).then(res => {
                    if (res.code == 2000) {
                        this.addfee = false;
                        this.$message.success(res.data);
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            } else {
                // let dtl = this.$refs.table.getTableData().fullData;
                interestUpdate({
                    id: this.interesttype_id,
                    interesttype_no: this.interesttype_no,
                    interesttype_name: this.interesttype_name,
                    remark: this.remark,
                    dtl: [],
                    type: '0'
                }).then(res => {
                    if (res.code == 2000) {
                        this.addfee = false;
                        this.$message.success(res.data);
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
        },
        plCheck() {
            if (this.selectList.length <= 0) {
                this.$message.error('请选择数据,进行批量审核');
                return;
            } else {
                interestCheck({
                    id: this.selectList.join(','),
                    check: '1'
                }).then(res => {
                    if (res.code == 2000) {
                        this.addfee = false;
                        this.$message.success(res.data);
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
        },
        plNoCheck() {
            if (this.selectList.length <= 0) {
                this.$message.error('请选择数据,进行批量反审');
                return;
            } else {
                interestCheck({
                    id: this.selectList.join(','),
                    check: '0'
                }).then(res => {
                    if (res.code == 2000) {
                        this.addfee = false;
                        this.$message.success(res.data);
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
        },
        plDtl() {
            if (this.selectList.length <= 0) {
                this.$message.error('请选择数据,进行批量删除');
                return;
            } else {
                this.$confirm('该利息方案中的产品数据将被一起删除，是否删除？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        interestDel({
                            id: this.selectList.join(','),
                            login_staff: localStorage.getItem('ms_username')
                        }).then(res => {
                            if (res.code == 2000) {
                                this.addfee = false;
                                this.$message.success(res.data);
                                this.pageIndex = 1;
                                this.getData();
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    })
                    .catch(() => {});
            }
        },
        deleteFee(row) {
            this.$confirm('该利息方案中的产品数据将被一起删除，是否删除？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    interestDel({
                        id: row.id,
                        login_staff: localStorage.getItem('ms_username')
                    }).then(res => {
                        if (res.code == 2000) {
                            this.addfee = false;
                            this.$message.success(res.data);
                            this.pageIndex = 1;
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isEdit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        // 编辑
        edit() {
            this.isEdit = false;
            let length = this.$refs.table.getTableData().fullData;
            if (length.length == 0) {
                setTimeout(() => {
                    for (let i = 0; i < 5; i++) {
                        this.insertEvent(-1);
                    }
                }, 100);
            } else {
            }
        },
        // 保存
        saveIt() {
            let dtl = this.$refs.table.getTableData().fullData;
            interestUpdate({
                id: this.wageType.interesttype_id,
                interesttype_no: this.wageType.interesttype_no,
                interesttype_name: this.wageType.interesttype_name,
                remark: this.wageType.remark,
                dtl,
                type: '1'
            }).then(res => {
                if (res.code == 2000) {
                    this.isEdit = true;
                    this.$message.success(res.data);
                    this.getDetail();
                    this.$forceUpdate();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isEdit = true;
            interestDtlIndex({ pid: this.wageType.interesttype_id, interesttype_no: this.wageType.interesttype_no }).then(res => {
                this.laborCostTable = res.data;
            });
            this.getData();
        },
        // 搜索方案
        search() {
            let item = this.laborCostData.filter(item => this.seek == item.interesttype_no);

            if (item.length > 0) {
                this.wageType = item[0];
                this.getDetail();
            } else {
                this.$message.error('未找到对应编号');
            }
        },
        checkType(e, row) {
            row.items_no = '';
        },
        formatStyletype(value) {
            if (Object.keys(this.pullData).length > 0) {
                if (value) {
                    let bill = this.pullData.itemstype_dat.filter(item => item.kind_no == value);
                    if (bill.length > 0) {
                        return bill[0].kind_name;
                    } else {
                        return value;
                    }
                }
            }
        },
        //处理产品名称回显
        formatStyle(value, row) {
            if (Object.keys(this.pullData).length > 0) {
                if (row.itemstype_no == 'metal') {
                    if (value) {
                        let bill = this.pullData.metal.filter(item => item.kind_no == value);
                        if (bill.length > 0) {
                            return bill[0].kind_name;
                        } else {
                            return value;
                        }
                    }
                } else if (row.itemstype_no == 'money') {
                    if (value) {
                        let bill = this.pullData.money.filter(item => item.kind_no == value);
                        if (bill.length > 0) {
                            return bill[0].kind_name;
                        } else {
                            return value;
                        }
                    }
                }
            }
        },
        // 列表出现新增
        tableenter(row) {
            if (!this.isEdit) {
                this.tableIndex = row.$rowIndex;
            }
        },
        tableleave() {
            this.tableIndex = '-1';
        },
        myfocus() {},
        addTable() {
            // this.addtable = true;
            this.insertEvent(-1);
        },
        //tbale增加条数
        async insertEvent(row) {
            let record = {};
            let { row: newRow } = await this.$refs.table.insertAt(record, row);
            await this.$refs.table.setActiveCell(newRow, 'seq');
        },
        addTableComfirm() {
            interestDtlAdd({ ...this.form, interesttype_no: this.leftIndex }).then(res => {
                if (res.code == 2000) {
                    this.addtable = false;
                    this.$message.success('添加成功');
                    this.getDetail();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        deleteIt(scoped) {
            let length = this.$refs.table.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.table.remove(scoped.row);
            // let length = this.$refs.table.getCheckboxRecords();
            // if (length.length == 0) {
            //     this.$message.error('请选择你要删除的');
            // } else {
            //     this.$XModal.confirm('您确定要删除该数据?').then(type => {
            //         if (type === 'confirm') {
            //             this.$refs.table.removeCheckboxRow();
            //         }
            //     });
            // }
        },
        // 导出
        outExcel(type) {
            this.$axios
                .get(this.$baseURL + 'interest_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        interesttype_no: this.wageType.interesttype_no,
                        pid: this.wageType.interesttype_id,
                        type: type
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    if (type == '方案明细') {
                        link.download = '利息方案.xlsx';
                    } else {
                        link.download = '利息模板.xlsx';
                    }

                    link.click();
                });
        },
        // 批量操作
        handleCommand(command) {
            if (command == 1) {
                this.inExcels();
            } else if (command == 2) {
                this.outExcel('方案明细');
                // document.querySelector('.biaoge input').click();
            } else if (command == 3) {
                this.outExcel('导入模板');
            }
        },
        // 导入
        inExcels() {
            if (this.laborCostTable.length != 0) {
                this.$confirm('此操作将会清空当前方案明细，是否继续？', '提示', {
                    confirmButtonText: this.$t('common.confirm') ,
                    cancelButtonText: this.$t('common.cancel') ,
                    type: 'warning'
                })
                    .then(() => {
                        document.querySelector('.biaoge input').click();
                        // this.$message({
                        //     type: 'success',
                        //     message: '删除成功!'
                        // });
                    })
                    .catch(() => {});
            } else {
                document.querySelector('.biaoge input').click();
            }
        },
        inExcel(file) {
            let data = new FormData(); //创建form对象
            data.append('file', file.raw);
            data.append('pid', this.wageType.interesttype_id);
            data.append('interesttype_no', this.wageType.interesttype_no);
            interestImport(data).then(res => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                } else {
                    if (res.code == 4001) {
                        let str = [];
                        var s = '';
                        str = res.data;
                        for (let i = 0; i < str.length; i++) {
                            s += str[i].error + '<br/>';
                        }
                        this.$message({
                            type: 'error',
                            showClose: true,
                            duration: 0,
                            dangerouslyUseHTMLString: true,
                            message: s
                        });
                    } else {
                        this.$message.error(res.data.info);
                    }
                }
                this.getData();
                interestDtlIndex({ pid: this.wageType.interesttype_id, interesttype_no: this.wageType.interesttype_no }).then(res => {
                    this.laborCostTable = res.data;
                });
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '89'
            }).then(res => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped lang="scss">
/deep/.vxe-table--render-default .vxe-body--row.row--stripe {
    // background-color: #f5f9ff;
}
.warpper {
}
.add_ {
    font-size: 20px;
}
.contant {
    display: flex;
    .left_warpper {
        width: 220px;
        position: relative;
        overflow: hidden;
        background-color: #fff;
        margin-right: 20px;
    }
    .left {
        position: absolute;
        top: 65px;
        right: -20px;
        width: 240px;
        background-color: #fff;
        height: 750px;
        overflow-y: scroll;
        padding-bottom: 65px;
        box-sizing: border-box;
        li {
            width: 100%;
            height: 40px;
            line-height: 40px;
            padding: 0 20px;
            box-sizing: border-box;
            font-size: 14px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                width: 190px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .on {
            background-color: #f5f9ff;
            color: #0084ff;
        }
    }
    .search {
        display: flex;
        padding: 0 10px;
        margin-top: 16px;
        margin-bottom: 22px;
    }

    .right {
        width: 0;
        flex: 1;
        background-color: #fff;
        padding: 15px;
        box-sizing: border-box;
        height: 750px;
        .table_head {
            display: flex;
            // flex-direction: column;
            // align-items: flex-end;
            .top {
                margin-bottom: 15px;
            }
        }
    }
}
.headers {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    div {
        display: flex;
    }
}
.form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-form-item {
        width: 48%;
    }
    .remark {
        width: 100%;
    }
}
</style>
